module.exports = __webpack_public_path__ + "img/new.04b3467a.svg";